module.exports = __webpack_public_path__ + "img/VetoSansCond-MediumItalic.5d028d9d.svg";